export default <T>(_value: T): true => true
